// extracted by mini-css-extract-plugin
export default {"popup-note-history":"PopupNoteHistory_popup-note-history__yJH+N","selection":"PopupNoteHistory_selection__XE3sE","popup-inner":"PopupNoteHistory_popup-inner__8c9-3"};